export const IST_TIME_ZONE = "Asia/Kolkata";

const toDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatISTDateTime = (value, fallback = "N/A") => {
  const date = toDate(value);
  if (!date) return fallback;
  return new Intl.DateTimeFormat("en-IN", {
    dateStyle: "medium",
    timeStyle: "medium",
    timeZone: IST_TIME_ZONE,
  }).format(date);
};

export const formatISTDate = (value, fallback = "N/A") => {
  const date = toDate(value);
  if (!date) return fallback;
  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: IST_TIME_ZONE,
  }).format(date);
};

export const formatISTDateLong = (value, fallback = "N/A") => {
  const date = toDate(value);
  if (!date) return fallback;
  return new Intl.DateTimeFormat("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: IST_TIME_ZONE,
  }).format(date);
};
